/** Path prefix used to proxy traffic to google analytics */
export const gtagFirstPartyProxyPrefix = '/api-ga-path-passthrough';
export const gtagProxyPrefixSliceLength = gtagFirstPartyProxyPrefix.length;

// export const gtagId = 'GTM-KL43S3BZ';
export const gtagId = 'G-2CEQMVFDFR';
